export default __webpack_public_path__ + "c098443b7e6e1fcb273f3180646e6200.png";